import { render } from "./DynamicHtmlEm.vue?vue&type=template&id=087af72a&ts=true"
import script from "./DynamicHtmlEm.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlEm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlEm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "087af72a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('087af72a', __exports__)) {
    api.reload('087af72a', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlEm.vue?vue&type=template&id=087af72a&ts=true", () => {
    api.rerender('087af72a', render)
  })

}


export default __exports__